import type { paths } from '@/types/api';
import { fetchClient, isApiErrorV2 } from '@/util/fetchClient';

type SuccessResponse =
  paths['/v2/public/questions']['post']['responses']['201']['content']['application/json'];

type EmailExistsResponse =
  paths['/v2/public/questions']['post']['responses']['409']['content']['application/json'];

type SubmitPublicQuestionResult = SuccessResponse | EmailExistsResponse;

export async function submitPublicQuestion(body: {
  email: string;
  message: string;
}): Promise<SubmitPublicQuestionResult> {
  try {
    const { data, error } = await fetchClient.POST('/v2/public/questions', {
      body,
    });

    if (error) {
      throw new Error('Failed to submit question');
    }

    return data as SubmitPublicQuestionResult;
  } catch (error) {
    if (isApiErrorV2(error) && error.status === 409) {
      return error.body as EmailExistsResponse;
    }

    throw error;
  }
}
